import script from "./GenerationsDB.vue?vue&type=script&setup=true&lang=js"
export * from "./GenerationsDB.vue?vue&type=script&setup=true&lang=js"

import "./GenerationsDB.vue?vue&type=style&index=0&id=fd8e712a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fd8e712a"]])

export default __exports__